module.exports = __webpack_public_path__ + "static/sortbookmarks-81fe84440e0ceef58fe93790e63dec85.mp4";